import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ApiV2 } from '@.api';
import { Layout } from '@.layout';
import { Table2 } from '@.partials';
import { Button, Filter3 } from '@.ui';
import { LinkHelper } from '@/Services';
import { Request } from '@/Types';
import { SpClusterResource } from '@/Types/serviceProviderClusters';

import S from './StoreClsuterPage.module.scss';

export const StoreClusterPage = () => {
    const navigate = useNavigate();

    const toCreateCluster = () => navigate(LinkHelper.serviceProvider.createStoreCluster);

    const get = useCallback((q?: Request.All) => {
        const query = {
            ...q,
            q: q?.search,
            search: undefined,
        };

        return ApiV2.serviceProviderClusters().listClusters(query);
    }, []);

    const deleteStoreCluster = async (storeClusterId: number) => {
        await ApiV2.serviceProviderClusters().deleteCluster(storeClusterId);

        get();
    };

    const getData = useCallback((data: any) => data.sp_clusters.items, []);

    return (
        <Layout name="Store clusters">
            <h1 className={S.title}>
                Store clusters
                <div className={S.title__buttons}>
                    <Button type="button" color="brown" text="Create new cluster" onClick={toCreateCluster} />
                </div>
            </h1>

            <Table2<any, SpClusterResource[]> get={get} getData={getData} getPaginationObject={(data) => data.sp_clusters.pagination}>
                {{
                    filters: (handleChange) => (
                        <Filter3 onChange={handleChange}>
                            <Filter3.Search />
                        </Filter3>
                    ),
                    items: [
                        (item) => ({
                            name: 'Name of store cluster',
                            max: 20,
                            content: item.name,
                        }),
                        (item) => ({
                            name: 'Stores count',
                            max: 20,
                            content: item.stores_count,
                        }),
                        (item) => ({
                            name: 'Number of stations/devices',
                            max: 10,
                            content: item.stations_count,
                        }),
                    ],
                    actions: [
                        (item) => ({
                            type: 'open',
                            link: LinkHelper.serviceProvider.storeClusterDetail(item.id),
                        }),
                        (item) => ({
                            type: 'edit',
                            link: LinkHelper.serviceProvider.editStoreCluster(item.id),
                        }),
                        (item) => ({
                            type: 'dashboard',
                            link: LinkHelper.serviceProvider.storeClusterAdminDashboard(item.id),
                        }),
                        (item) => ({
                            type: 'delete',
                            onClick: () => deleteStoreCluster(item.id),
                        }),
                    ],
                }}
            </Table2>
        </Layout>
    );
};
